module.exports = "<seeya-import-export-game></seeya-import-export-game>\r\n\r\n<seeya-add-scene></seeya-add-scene>\r\n\r\n<mat-grid-list cols=\"{{columns}}\" rowHeight=\"300px\" gutterSize=\"1em\">\r\n  <mat-grid-tile\r\n      *ngFor=\"let scene of getScenes()\">\r\n      <seeya-scene class=\"scene\" [scene]=\"scene\"></seeya-scene>\r\n  </mat-grid-tile>\r\n</mat-grid-list>"


//////////////////
// WEBPACK FOOTER
// C:/Repos/seeya/src/app/generator/generator.component.html
// module id = ../../../../../src/app/generator/generator.component.html
// module chunks = main